define('collections/reseller_roles',['require','collections/base','models/reseller_role'],function (request) {
    var BaseCollection = require('collections/base');
    var Model = require("models/reseller_role");
    return BaseCollection.extend({
        model : Model,
        url:"reseller-roles.json"
    });
});
